module.exports = __webpack_public_path__ + "static/media/outreach.cf9bb1a7.jpg";